import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableDataConfigComponent } from './data-table-data-config.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ColumnMapperComponent } from './column-mapper/column-mapper.component';
import { ColumnItemComponent } from './column-mapper/column-item/column-item.component';
import { LunaCommonModule } from '../../../../../../../common/common.module';
//import { DragulaModule } from 'ng2-dragula';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { QueryService } from '../../../../../../../common/services/query.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PropertySelectorModule } from './column-mapper/column-item/property-selector/property-selector.module';
import { GridOptionConfigComponent } from './grid-option-config/grid-option-config.component';
import { DataQueryButtonConfigModule } from '../data-query-button-config.module';
import { CommonConfigModule } from '../../common/common.module';
import { ArraySelectorOptionsComponent } from './column-mapper/column-item/formatter-settings/array-selector-options/array-selector-options.component';
import { FlagEnumOptionsComponent } from './column-mapper/column-item/formatter-settings/flagEnum-options/flagEnum-options.component';
import { DomainOptionsComponent } from './column-mapper/column-item/formatter-settings/domain-options/domain-options.component';

@NgModule({ declarations: [
        DataTableDataConfigComponent,
        ColumnMapperComponent,
        ColumnItemComponent,
        GridOptionConfigComponent,
        ArraySelectorOptionsComponent,
        FlagEnumOptionsComponent,
        DomainOptionsComponent
    ],
    exports: [
        DataTableDataConfigComponent,
        GridOptionConfigComponent,
        ColumnMapperComponent
    ], imports: [CommonModule,
        FormsModule,
        DataQueryButtonConfigModule,
        CommonConfigModule,
        ReactiveFormsModule,
        LunaCommonModule,
		//DragulaModule,
		DragDropModule,
        PropertySelectorModule], providers: [
        QueryService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class DataTableConfigModule { }
